export const STEP_ID_INVOICES = 'justificatifs'
export const STEP_ID_BANK_INFORMATIONS = 'informations-bancaires'
export const STEP_ID_INCOMES = 'chiffre-d-affaires'
export const STEP_ID_SETTLEMENTS = 'virements'

export const STEP_NAMES = [
  STEP_ID_INVOICES,
  STEP_ID_SETTLEMENTS,
  STEP_ID_BANK_INFORMATIONS,
  STEP_ID_INCOMES,
] as const
